import PropTypes from 'prop-types';

import config from '@plone/volto/registry';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { resolveRichTextHtml } from '../../../helpers/richTextHtml';

import {
  TAB_ALLOWED_BLOCKS,
  pickNestedBlocksConfig,
} from '../../../config/nestedBlocks';

const getTabBlocksConfig = () =>
  config.blocks.blocksConfig.csjTabs?.blocksConfig ||
  pickNestedBlocksConfig(config.blocks.blocksConfig, TAB_ALLOWED_BLOCKS);

const TabContent = ({ tab, path, metadata }) => {
  const layoutItems = tab?.blocks_layout?.items || [];

  if (layoutItems.length) {
    const blocksConfig = getTabBlocksConfig();

    return (
      <RenderBlocks
        content={{
          blocks: tab.blocks || {},
          blocks_layout: tab.blocks_layout || { items: [] },
        }}
        path={path}
        metadata={metadata}
        blocksConfig={blocksConfig}
      />
    );
  }

  if (tab?.content) {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: resolveRichTextHtml(tab.content),
        }}
      />
    );
  }

  return null;
};

TabContent.propTypes = {
  tab: PropTypes.objectOf(PropTypes.any).isRequired,
  path: PropTypes.string,
  metadata: PropTypes.objectOf(PropTypes.any),
};

export default TabContent;
